import React, { useState } from "react";
import { ButtonItem } from "../../Pages/Conference/style";
// import Grid from "@mui/material/Grid";
import Grid from '@mui/material/Unstable_Grid2';

// import { Menus } from "../../Pages/Audio/style";
import DotIcon from "@mui/icons-material/FiberManualRecord";
import { OnioTabStyles } from "./styles";
import { useMediaQuery } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import './style.css'

interface ownProps {
  menu: string[],
  onClick?: (ele: any, i: number) => void
}
const OnioTabs: React.FC<ownProps> = (props: ownProps) => {

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'))
  const [selectedMenu, setSelectedmenu] = useState<number>(0);
  const menuHandler = (ele: any, i: number) => {
    props.onClick!(ele, i)
    setSelectedmenu(i);
  };

  return (
    <div>
      {
        isMobile ?
          <div className="lights-scroll tab-scroll">
            {props.menu.map((ele, i) => {
              return (
                <ButtonItem key={i}
                  sx={{ ...OnioTabStyles(theme), color: selectedMenu === i ? "#E7F011" : "" }}
                  onClick={() => { menuHandler(ele, i) }}
                >
                  <DotIcon
                    fontSize="small"
                    sx={{
                      width: 10,
                      height: 10,
                      marginRight: "5px",
                      color: selectedMenu === i ? "inherit" : "#121212",
                    }}
                  />
                  {ele}
                </ButtonItem>
              );
            })}
          </div> :
          <Grid container spacing={4} sx={{ ...OnioTabStyles, mt: 1 }} className="Menu">
            {props.menu.map((ele, i) => {
              return (
                <Grid key={i} >
                  <ButtonItem
                    sx={{ color: selectedMenu === i ? "#E7F011" : "" }}
                    onClick={() => { menuHandler(ele, i) }}
                  >
                    <DotIcon
                      fontSize="small"
                      sx={{
                        width: 10,
                        height: 10,
                        marginRight: "5px",
                        color: selectedMenu === i ? "inherit" : "#121212",
                      }}
                    />
                    {ele}
                  </ButtonItem>
                </Grid>
              );
            })}
          </Grid>
      }

    </div>
  );
};

export default OnioTabs;
